export enum BuySell {
  Sell = 1,
  Buy = 2,
}